<label :class="(disabled || readonly) && 'disabled-switch'" class="container">
  <input
    v-bind="$attrs"
    :disabled="disabled || readonly"
    class="input"
    :class="disabled ? 'input-disabled' : ''"
    type="checkbox"
    :checked="checked === true || checked === 1"
    @change="onChange"
  />
  <span class="switch"></span>
  <span v-if="label" class="label">{{ $t(label) }}</span>
</label>
